import { useState  } from "react";

const useMessages = () => {
  const [messages, setMessages] = useState({
    success: "",
    error: "",
  });

  // useEffect(() => {
  //   if (messages.error ||  messages.success) {
  //       const timer = setTimeout(() => {
  //           setMessages({success : "" , error: ""});
  //       }, 10000);
  //       return ()=> clearTimeout(timer);
  //   }
  // }, [messages])

  const handleSuccess = (msg) => {
    setMessages({ success: msg, error: "" });
  };

  const handleError = (msg) => {
    setMessages({ success: "", error: msg });
  };

  const clearMessages = () => {
    setMessages({ success: "", error: "" });
  };

  return {
    messages,
    handleSuccess,
    handleError,
    clearMessages,
  };
};

export default useMessages;